// @ts-strict-ignore
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';

import { CurrentUser } from 'api/currentUser';
import { SearchSection } from 'api/types/shared.types';
import { SearchInputs } from 'components/Search/SearchInputs';
import {
  clearSearchLocation,
  setSearchFilter,
  setSearchQuery,
  updateSearchLocation,
} from 'store/staff/ducks/search';
import { DisplayedType, listingTypesBySection } from 'utils/constants';
import { filterObject, isEmpty, mapObject, values } from 'utils/functional';
import { truncateToUTF8Bytes } from 'utils/string';

type InitialProps = {
  // @ts-expect-error ts-migrate(2300) FIXME: Duplicate identifier 'onSearch'.
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSearch?: (arg0: Record<string, any>) => void;
  inPageHeader?: boolean;
  // @ts-expect-error ts-migrate(2300) FIXME: Duplicate identifier 'onSearch'.
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSearch: (...args: Array<any>) => any;
  // NB this isn't used here. kept for compatibility with SearchInputsContainer
  // eslint-disable-next-line react/no-unused-prop-types
  searchSection?: SearchSection;
};

type OwnProps = InitialProps & RouteComponentProps;

type Props = OwnProps & {
  type: StaffTypeFilter | null | undefined;
  query: string;
  searchLocation: SearchLocation | null | undefined;
  setSearchQuery: typeof setSearchQuery;
  setSearchFilter: typeof setSearchFilter;
  updateSearchLocation: typeof updateSearchLocation;
  clearSearchLocation: typeof clearSearchLocation;
  currentUser: CurrentUser;
};
type State = {
  type: StaffTypeFilter | null | undefined;
  query: string;
  searchLocation: SearchLocation | null | undefined;
  prevProps: {
    type: StaffTypeFilter | null | undefined;
    query: string;
    searchLocation: SearchLocation | null | undefined;
  };
};

// @TODO - move elsewhere
const toQueryParamKey = (k: string) => {
  const mapping = {
    query: 'q',
  };
  return mapping[k] || k;
};

const makeQueryString = (props: { type?: string; query?: string }) => {
  const search = values(
    mapObject(
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ type?: string; query?: string;... Remove this comment to see the full error message
      filterObject(props, (k) => !isEmpty(k)),
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
      (k, v) => [k, `${toQueryParamKey(k)}=${v}`]
    )
  ).join('&');
  return isEmpty(search) ? '' : `?${search}`;
};

class StaffSearchInputsContainer extends React.Component<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    type: this.props.type || 'ALL',
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    query: this.props.query || '',
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    searchLocation: this.props.searchLocation,

    prevProps: {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      type: this.props.type,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      query: this.props.query,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      searchLocation: this.props.searchLocation,
    },
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    const updatedState = ['type', 'query', 'searchLocation'].reduce(
      (acc, prop) => {
        if (props[prop] !== state.prevProps[prop]) {
          // eslint-disable-next-line no-param-reassign
          acc[prop] = props[prop];
        }

        return acc;
      },
      {}
    );

    if (Object.keys(updatedState).length > 0) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'prevProps' does not exist on type '{}'.
      updatedState.prevProps = {
        type: props.type,
        query: props.query,
        searchLocation: props.searchLocation,
      };
      return updatedState;
    }

    return null;
  }

  setListingType = (listingType: StaffTypeFilter | null | undefined) => {
    this.setState({
      type: listingType,
    });
  };

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setQuery = (query: string, callback?: (...args: Array<any>) => any) => {
    // Algolia has a max query length of 512 bytes
    this.setState(
      {
        query: truncateToUTF8Bytes(query, 512),
      },
      callback
    );
  };

  setSearchLocation = (searchLocation: SearchLocation | null | undefined) => {
    this.setState(
      {
        searchLocation,
      },
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      () => this.search(this.state.query)
    );
  };

  search = (query: string) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.type !== this.state.type) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.setSearchFilter('type', this.state.type);
    }

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.query !== query) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.setSearchQuery(query);
    }

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.searchLocation !== this.state.searchLocation) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line prefer-destructuring, react/destructuring-assignment
      const searchLocation = this.state.searchLocation;

      if (searchLocation) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.updateSearchLocation(searchLocation);
      } else {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.clearSearchLocation();
      }
    }

    const queryString = makeQueryString({
      query,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      type: this.state.type || '',
    });
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    this.props.history.push(`/staff${queryString}`);
  };

  render() {
    const { type, query, searchLocation } = this.state;
    const { setListingType, setQuery, setSearchLocation, search, props } = this;
    const listingTypes: Array<DisplayedType> = listingTypesBySection.STAFF;
    const selectedType =
      listingTypes.find((l) => l === type) ||
      (listingTypes.includes('JOB') ? 'JOB' : listingTypes[0]);

    const clearSearchInput = () => {
      setQuery('', () => search(''));
    };

    return (
      <SearchInputs
        listingTypes={listingTypes}
        selectedType={selectedType}
        onSearch={props.onSearch}
        query={query}
        clearSearchInput={clearSearchInput}
        searchLocation={searchLocation}
        setListingType={setListingType}
        setQuery={setQuery}
        setSearchLocation={setSearchLocation}
        search={search}
        inPageHeader={props.inPageHeader}
        currentUserLoaded={props.currentUser.isLoaded}
      />
    );
  }
}

const mapStateToProps = ({
  search: {
    query,
    filters: { type },
    searchLocation,
  },
  currentUser,
}) => ({
  query,
  type,
  searchLocation,
  currentUser,
});

// eslint-disable-next-line import/no-default-export
export default withRouter(
  connect(mapStateToProps, {
    setSearchFilter,
    setSearchQuery,
    updateSearchLocation,
    clearSearchLocation,
  })(StaffSearchInputsContainer)
);
